<template>
    <div>
        <v-skeleton-loader type="table-tbody" v-if="$store.state.loading"></v-skeleton-loader>

        <v-table class="result_table" density="compact" v-else style="border-radius: 5px">
            <thead class="bg-secondary">
                <tr>
                    <th>Clt</th>
                    <th>Equipe</th>
                    <th>Temps</th>

                </tr>
            </thead>
            <tbody v-if="filteredRunners.length > 0">
                <template v-for="(runner, id_runner) in filteredRunners" :key="id_runner">
                    <tr>
                        <td>
                            <b>{{ getCltSexe(runner) }}</b>
                        </td>
                        <td>
                            <b>{{ runner.equipe_name }}</b> - {{ runner.runner_names }} [Doss. {{ runner.dossard }}]
                        </td>
                        <td>
                            <b class="text-accent" style="font-size: 1.1rem">{{ getTemps(runner) }}</b>
                        </td>

                    </tr>

                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5" v-if="filters.sexe != 'Tous' || filters.search != ''" class="text-center">Aucun
                        participant ne
                        correspond à votre recherche</td>
                    <td colspan="5" v-else class="text-center">En attente des résultats</td>
                </tr>
            </tbody>
        </v-table>

        <v-dialog v-model="show_dialog" width="500">
            <v-card>
                <v-card-text>
                    <RunnerDetails :runner="selected_runner"></RunnerDetails>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secondary" block @click="show_dialog = false">Fermer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import RunnerDetails from "@/components/Resultats/RunnerDetails.vue";
export default {
    components: {
        RunnerDetails,
    },
    props: [],
    data() {
        return {
            expandedDossard: null,
            show_dialog: false,
            selected_runner: null,
        };
    },
    computed: {
        filters() {
            return this.$store.state.filters;
        },
        filteredRunners() {
            if (!this.$store.getters.getEpreuveResults) return [];
            let runners = this.$store.getters.getEpreuveResults;



            const filters = this.$store.state.filters;



            if (filters.search != "") {
                const q = filters.search.toLowerCase();
                runners = runners.filter((runner) => {
                    const names = `${runner.equipe_name || ""} ${runner.runner_names || ""}`.toLowerCase();
                    return names.includes(q);
                });
            }

            return runners;
        },
    },
    methods: {
        getClt(runner) {
            const current_epreuve = this.$store.state.current_epreuve;
            if (current_epreuve === "kayak") {
                return runner.kayak?.clt ?? "—";
            } else if (current_epreuve === "trail") {
                return runner.trail?.clt ?? "—";
            } else if (current_epreuve === "penalite") {
                return "-";
            }
            return null;
        },
        getTemps(runner) {
            const current_epreuve = this.$store.state.current_epreuve;
            if (current_epreuve === "kayak") {
                return runner.kayak?.temps ?? "—";
            } else if (current_epreuve === "trail") {
                return runner.trail?.temps ?? "—";
            } else if (current_epreuve === "penalite") {
                return runner.penalite.temps;
            }
            return null;
        },
        getCltSexe(runner) {
            const current_epreuve = this.$store.state.current_epreuve;
            if (current_epreuve === "kayak") {
                const c = runner.kayak?.clt_sexe;
                return (c != null ? c : "—");
            } else if (current_epreuve === "trail") {
                const c = runner.trail?.clt_sexe;
                return (c != null ? c : "—");
            } else if (current_epreuve === "penalite") {
                return "-";
            }
            return null;
        },
    },
};
</script>

<style scoped></style>
